<template>
  <b-row>
    <b-col>
      <divisoria-descricao
        :titulo="'Modelos e documentos'"
        :descricao="'Selecione o modelo de documentos que esta empresa utiliza e personalize adicionando documentos ou inativando'"
      >
        <template
          v-if="empresa.modelo"
          slot="complemento-titulo"
        >
          <span :class="['status-badge', {'badge badge-danger':(!empresa.modelo.ativo && empresa.modelo.id > 0), '':empresa.modelo.ativo}]">
            {{ !empresa.modelo.ativo && empresa.modelo.id > 0 ? 'Inativo' : '' }}
          </span>
        </template>
      </divisoria-descricao>
      <b-row
        b-row
        align-h="between"
      >
        <b-col cols="6">
          <div style="display: flex;align-items: center;">
            <modelo-select
              v-model="empresa.modelo"
              :clearable="true"
              :apenas-ativos="true"
              style="width: 100%;"
              @input="carregaDocumentos($event)"
            />
            <b-btn
              v-b-tooltip.top="'Replicar modelo e documentos'"
              variant="none"
              size="sm"
              class="mr-50"
              style="width: 1%;"
            >
              <font-awesome-icon
                :icon="faShareSquare"
                class="text-primary"
                style="font-size:1.3rem !important;"
                @click="abrirModalReplicar"
              />
            </b-btn>
          </div>
        </b-col>
        <b-col cols="auto">
          <div class="bv-no-focus-ring col-form-label pt-0">
            &nbsp;
          </div>
          <b-btn
            variant="none"
            class="btn btn-sm btn-outline-primary"
            :disabled="!empresa.modelo || empresa.modelo.id == 0"
            @click="abrirEscolhaDocumento"
          >
            Adicionar documento
          </b-btn>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <modelo-documento
            ref="empresa-documentos"
            :value="empresaDocumentos"
            :aplicar-filtro="aplicarFiltro"
            :documentos-da-empresa="true"
          />
        </b-col>
      </b-row>
    </b-col>

    <b-modal
      :ref="'adicionarDocumento'"
      title="Adicione documentos customizadas a empresa"
      hide-footer
      centered
      no-close-on-backdrop
      @hidden="hide"
    >
      <b-row>
        <b-col cols="12">
          <departamento-select
            v-model="docCustomizado.departamento"
            :invalido="docCustomInvalido.departamento"
            @input="removeDocSelecionado"
          />
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12">
          <documento-select
            v-model="docCustomizado.documento"
            :disabled="docCustomizado && !docCustomizado.departamento"
            :departamento="docCustomizado.departamento ? docCustomizado.departamento.id : 0"
            :invalido="docCustomInvalido.documento"
            :apenas-ativos="true"
          />
        </b-col>
      </b-row>
      <b-row align-h="end">
        <b-col cols="auto">
          <b-btn
            class="btn btn-success "
            variant="none"
            @click="incluirDocumento()"
          >
            Incluir
          </b-btn>
        </b-col>
      </b-row>
    </b-modal>

    <replicar-configuracao-modelo
      v-if="mostrarReplicarConfiguracao"
      :empresa-id="empresa.id"
      @fechar-modal-configuracao="fecharConfiguracao"
      @iniciar-copia="copiarModelo($event)"
    />
  </b-row>
</template>

<style lang="scss">
.status-badge {
  height: 1.2rem;
  font-size: 10px;
  font-weight: 600;
  border-radius: 2px;
  margin-left: 0.5rem;
}
</style>

<script>
/* eslint-disable no-param-reassign */

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import {
  faShareSquare,
} from '@fortawesome/free-solid-svg-icons'
import { mapActions, mapGetters } from 'vuex'
import api from '@/app-modulo/documento/modelo/shared/services/api'
import apiEmpresa from '../../services/api'

export default {
  name: 'ModeloEmpresa',
  components: {
    FontAwesomeIcon,
    DivisoriaDescricao: () => import('@/shared/components/divisoria-descricao/DivisoriaDescricao.vue'),
    ModeloDocumento: () => import('../modelo-documento/ModeloDocumento.vue'),
    ModeloSelect: () => import('@/shared/components/modelo-select/ModeloSelect.vue'),
    DepartamentoSelect: () => import('@/shared/components/departamento-select/DepartamentoSelect.vue'),
    DocumentoSelect: () => import('@/shared/components/documento-select/DocumentoSelect.vue'),
    ReplicarConfiguracaoModelo: () => import('../replicar-configuracao-modelo/ReplicarConfiguracaoModelo.vue'),
  },
  data() {
    return {
      faShareSquare,
      docCustomizado: {},
      docCustomInvalido: {
        departamento: false,
        empresaDocumento: false,
      },
      aplicarFiltro: false,
      mostrarReplicarConfiguracao: false,
    }
  },
  computed: {
    ...mapGetters('empresa', ['empresa', 'empresaDocumentos', 'filtrarDocsModelo']),
  },
  watch: {
    filtrarDocsModelo(value, oldValue) {
      if (value !== oldValue) {
        this.aplicarFiltro = value
      }
    },
  },
  methods: {
    ...mapActions('empresa', ['setEmpresaDocumentos', 'adicionarDocumentoCustom', 'setFiltrarDocsModelo']),
    carregaDocumentos() {
      if (this.empresa.modelo !== null) {
        api.getModeloEmpresa(this.empresa.modelo.id)
          .then(payload => {
            this.setEmpresaDocumentos({ empresaDocumentos: payload.data.documentos, veioDoModelo: true, replicado: false })
            this.$refs['empresa-documentos'].$refresh(this.empresaDocumentos)
          })
      } else {
        this.empresa.empresaDocumentos = []
        this.empresa.contatos.forEach(contato => {
          contato.documentos = []
        })
      }
    },
    abrirEscolhaDocumento() {
      this.$refs.adicionarDocumento.show()
    },
    incluirDocumento() {
      this.docCustomInvalido.departamento = !this.docCustomizado.departamento
      this.docCustomInvalido.documento = this.docCustomizado.documento && !this.docCustomizado.documento

      if (this.docCustomizado.departamento && this.docCustomizado.documento) {
        this.docCustomizado.copia = false
        this.adicionarDocumentoCustom({
          empresaDocumento: this.docCustomizado.documento,
          departamento: this.docCustomizado.departamento,
          indexDepart: this.docCustomizado.indexDepart,
          copia: this.docCustomizado.copia,
        })
        this.$refs.adicionarDocumento.hide()
        this.$refs['empresa-documentos'].$refreshDepartameto(this.docCustomizado.departamento)
        this.docCustomizado = {}
        this.aplicarFiltro = true
      }
    },
    hide() {
      this.docCustomizado = {}
      this.docCustomInvalido.departamento = false
      this.docCustomInvalido.empresaDocumento = false
    },
    removeDocSelecionado(dep) {
      if (this.docCustomizado.empresaDocumento) {
        this.docCustomizado = {}
        this.docCustomizado.departamento = dep
        // this.$refs['empresa-documentos'].$refresh(dep)
      }
    },
    abrirModalReplicar() {
      this.mostrarReplicarConfiguracao = true
    },
    fecharConfiguracao() {
      this.mostrarReplicarConfiguracao = false
    },
    copiarModelo(form) {
      this.$isLoading(true)
      apiEmpresa.replicarConfiguracaoModelo(this.empresa.id ? this.empresa.id : 0, form)
        .then(payload => {
          this.empresa.modelo = payload.data.modelo
          this.setEmpresaDocumentos({ empresaDocumentos: payload.data.empresaDocumento, veioDoModelo: true, replicado: true })
          this.$refs['empresa-documentos'].$refresh(this.empresaDocumentos)
          this.$isLoading(false)
        })
        .catch(err => {
          this.$isLoading(false)
          this.$erro(err.response.data.message || err.message)
          throw err
        })
    },
  },
}
</script>
